import { Injectable } from '@angular/core';
import { ActionData } from '@root/app.interfaces';
import { ServerDataService } from '@core/services/server-data/server-data.service';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';
import { STORAGE_NAMES } from '@root/app.config';

@Injectable({
	providedIn: 'root',
})
export class ActionTrackingService {
	private readonly TRACKED_SELECTORS = ['exit_button', 'send_request', 'download_pdf', 'download_image', 'save_your_work'];

	constructor(
		private serverDataService: ServerDataService,
		private sessionStorageService: SessionStorageService,
	) {
		this.initActionTracking();
	}

	private initActionTracking(): void {
		document.addEventListener('click', (event: Event) => {
			const target = event.target as HTMLElement;
			const targetDataAttribute = target?.getAttribute('data-action-id');

			if (this.TRACKED_SELECTORS.includes(targetDataAttribute)) {
				this.logAction('click', targetDataAttribute);
			}
		});
	}

	private logAction(type: string, elementSelector: string): void {
		const actionData: ActionData = {
			session_key: this.sessionStorageService.getSession(STORAGE_NAMES.zip_blind_config).session_key,
			action_type: type,
			element: elementSelector,
			page_url: window.location.pathname.slice(1),
			device_info: navigator.userAgent,
			created_at: new Date(),
		};

		this.serverDataService.PostActionData(actionData).subscribe();
	}
}
